import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import FaqBlock from './FaqBlock'

import { useTranslation } from 'react-i18next'

const FaqListingBlock = ({ block }) => {
  const { t } = useTranslation()

  const result = useStaticQuery(
    graphql`
      query {
        allFaq {
          nodes {
            answer
            category_ids
            faqId
            id
            question
          }
        }
      }
    `
  )
  const selectedCategoryId = block.category
  const faqs = result.allFaq.nodes.filter((node) =>
    node.category_ids.includes(parseInt(selectedCategoryId))
  )

  return (
    <FaqBlock
      block={{
        headline:
          block?.headline?.length > 0
            ? block.headline
            : t('generic.service_and_faq'),
        faq_items: faqs,
      }}
    />
  )
}

export default FaqListingBlock
